export default "__VITE_ASSET__043ca4b6__"